export default {"src":"/_next/static/media/remove.d63df0d3.svg","height":34,"width":34};